interface LiveStreamCardProps {
  stream: {
    id: string;
    churchName: string;
    service: string;
    location: string;
    thumbnail: string;
    isLive: boolean;
    viewers: number;
    startTime: string;
    videoUrl?: string;
  };
  viewMode: 'grid' | 'list';
  onClick: () => void;
}

export default function LiveStreamCard({ stream, viewMode, onClick }: LiveStreamCardProps) {
  return (
    <div
      onClick={onClick}
      className={`bg-white rounded-xl shadow-md hover:shadow-xl transition-all cursor-pointer group ${
        viewMode === 'list' ? 'flex items-center' : ''
      }`}
    >
      <div className="relative h-64 overflow-hidden">
        <img 
          src={stream.thumbnail}
          alt={stream.churchName}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
        />
        {stream.isLive && (
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        )}
        <div className="absolute top-3 left-3">
          <span className="px-3 py-1 bg-emerald-600 text-white text-xs font-bold rounded-full flex items-center space-x-1 shadow-lg">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
            </span>
            <span className="whitespace-nowrap">LIVE</span>
          </span>
        </div>
        {stream.isLive && stream.viewers && (
          <span className="px-3 py-1 bg-gray-900/80 backdrop-blur-sm text-white text-xs font-semibold rounded-full flex items-center space-x-1">
            <i className="ri-eye-line"></i>
            <span className="whitespace-nowrap">{stream.viewers.toLocaleString()}</span>
          </span>
        )}
        {stream.isLive && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-16 h-16 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
              <i className="ri-play-fill text-3xl text-rose-600"></i>
            </div>
          </div>
        )}
      </div>

      <div className="p-5">
        <div>
          <div className="text-xs font-semibold text-rose-600 mb-1 uppercase tracking-wide">
            {stream.service}
          </div>
          <h3 className="text-lg font-bold text-gray-900 mb-1 line-clamp-1" style={{ fontFamily: 'Noto Sans, system-ui, sans-serif' }}>
            {stream.churchName}
          </h3>
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <i className="ri-map-pin-line"></i>
            <span className="line-clamp-1">{stream.location}</span>
          </div>
        </div>

        <button
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
          className="w-full mt-4 py-2.5 bg-rose-600 text-white rounded-lg font-semibold hover:bg-rose-700 transition-colors flex items-center justify-center space-x-2 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-play-circle-line"></i>
          <span>Watch Now</span>
        </button>
      </div>
    </div>
  );
}
